module.exports = __webpack_public_path__ + "static/img/nals-3.f6d613f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/nals-3.jpg
// module id = UQuz
// module chunks = 0